// components/ContactUsModal/ContactUsModal.jsx
import React from "react";
import "./ContactUsModal.css";

const ContactUsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>تماس با ما</h2>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body">
          <div className="contact-info">
            <div className="info-item">
              <i className="fas fa-envelope"></i>
              <div>
                <h3>ایمیل</h3>
                <a href="mailto:umlang.adm@gmail.com">umlang.adm@gmail.com</a>
              </div>
            </div>

            <div className="info-item">
              <i className="fas fa-phone"></i>
              <div>
                <h3>تلفن</h3>
                <a href="tel:+989216065530">09216065530</a>
              </div>
            </div>

            <div className="info-item">
              <i className="fab fa-whatsapp"></i>
              <div>
                <h3>واتس‌آپ</h3>
                <a
                  href="https://wa.me/989216065530"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  09216065530
                </a>
              </div>
            </div>

            <div className="info-item">
              <i className="fab fa-telegram"></i>
              <div>
                <h3>تلگرام (پشتیبانی)</h3>
                <a
                  href="https://t.me/umlang_support"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  umlang_support@
                </a>
              </div>
            </div>

            <div className="info-item">
              <i className="fas fa-comment-dots"></i>
              <div>
                <h3>ایتا</h3>
                <a
                  href="https://eitaa.com/umlang_com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  umlang_com@
                </a>
              </div>
            </div>

            {/* آدرس - کامنت شده برای اصلاحات بعدی */}
            {/* <div className="info-item">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <h3>آدرس</h3>
                <p>ایران، تهران</p>
              </div>
            </div> */}

            <div className="info-item">
              <i className="fas fa-clock"></i>
              <div>
                <h3>ساعات کاری</h3>
                <p>شنبه تا پنجشنبه: ۹ صبح تا ۲۲ شب</p>
              </div>
            </div>
          </div>

          <div className="social-links">
            <h3>شبکه‌های اجتماعی</h3>
            <div className="social-icons">
              <a
                href="https://t.me/umlang"
                target="_blank"
                rel="noopener noreferrer"
                title="تلگرام"
              >
                <i className="fab fa-telegram"></i>
              </a>
              <a
                href="https://instagram.com/umlang_com"
                target="_blank"
                rel="noopener noreferrer"
                title="اینستاگرام"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>

          <div className="contact-message">
            <p>
              <i className="fas fa-info-circle"></i>
              ما معمولاً در کمتر از ۲۴ ساعت پاسخگوی پیام‌ها هستیم
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsModal;
